class SizeChart extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.table = this.querySelector('table');
    this.form.addEventListener('change', this.handleChange.bind(this));

    this.resize = this.resize.bind(this);
    this.resize();
    window.addEventListener('resize', this.resize);
  }

  handleChange(event) {
    event?.preventDefault();

    const size = this.form.size.value;
    const type = this.form.type.value;

    this.form.size.querySelectorAll('option').forEach(option => {
      option.innerHTML = option.getAttribute(`data-size-${type.replace('_', '-')}`);

      const isEmpty = option.textContent.trim() === '';
      option.style.display = isEmpty ? 'none' : '';
    });

    // Check if current selection is empty and select first non-empty option
    const currentOption = this.form.size.querySelector('option:checked');
    if (currentOption && currentOption.style.display === 'none') {
      const firstVisibleOption = this.form.size.querySelector('option:not([style*="display: none"])');
      if (firstVisibleOption) {
        firstVisibleOption.selected = true;
        this.form.size.value = firstVisibleOption.value;
        this.handleChange();
        return;
      }
    }

    this.table.querySelectorAll('tr').forEach(row => {
      row.classList.toggle('type-selected', row.dataset.type === type);
    });

    this.table.querySelectorAll('td').forEach(cell => {
      cell.classList.toggle('highlighted', cell.dataset.mondopoint === size);
    });

    const highlightedCell = this.table.querySelector('td.highlighted');
    if (highlightedCell) {
      const tableContainer = this.table.closest('.content');
      if (tableContainer) {
        const cellRect = highlightedCell.getBoundingClientRect();
        const containerRect = tableContainer.getBoundingClientRect();
        
        if (cellRect.left < containerRect.left || cellRect.right > containerRect.right) {
          highlightedCell.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center'
          });
        }
      }
    }
  }

  resize() {
    if (this.table) {
      const isScrollable = this.clientWidth < this.table.clientWidth;
      this.table.classList.toggle('sticky-header-column', isScrollable);
    }
  }
}

if (!customElements.get('size-chart')) {
  customElements.define('size-chart', SizeChart);
}